import { z } from "zod";

/**
 * Shared task output schema used by both createTask and generateTask tools/steps.
 */
export const taskOutputSchema = z.object({
  id: z.uuid(),
  title: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  priority: z.string(),
  assigneeType: z.string().nullable(),
  assigneeUserId: z.uuid().nullable(),
  assigneeAgentDefinitionId: z.uuid().nullable(),
  dueDate: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
  tags: z.array(z.string()).nullable(),
  createdAt: z.string(),
});
